import type { PreClaimsPercentageOrValueListResponse } from './api';

export const normalizePreClaimsPercentageOrValueList = (
  list: PreClaimsPercentageOrValueListResponse,
): {
  label: string;
  value: string;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.value,
    value: row.key,
  }));
};
